import { combineReducers } from 'redux';
import { coreApiGatewayKeysRemoveSyncSlice } from './remove';
import { coreApiGatewayKeysUpdateSyncSlice } from './update';
import { getCoreApiGatewayKeysSlice } from './get';
import { postCoreApiGatewayKeysSlice } from './post';

import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';
import { coreApiGatewayKeysByIdReducers, coreApiGatewayKeysByIdWatchers } from './_id';

export const coreApiGatewayKeysReducers = combineReducers({
	byId: coreApiGatewayKeysByIdReducers,
	get: joinReducers(
		[
			getCoreApiGatewayKeysSlice.asyncReducers,
			coreApiGatewayKeysRemoveSyncSlice.syncReducer,
			coreApiGatewayKeysUpdateSyncSlice.syncReducer
		],
		getCoreApiGatewayKeysSlice.asyncState
	),
	post: postCoreApiGatewayKeysSlice.asyncReducers
});

export const coreApiGatewayKeysWatchers = combineAllWatchers([
	coreApiGatewayKeysByIdWatchers,
	getCoreApiGatewayKeysSlice.asyncWatchers,
	postCoreApiGatewayKeysSlice.asyncWatchers
]);
